import 'angular';

import { DatePickerCtrl }      from './date-picker.ajs';
import { DatePickerDirective } from './date-picker.directive.ajs';

angular.module('app-lite.core.date-picker', [])
  .controller('DatePickerCtrl', DatePickerCtrl)
  .directive('datePicker', DatePickerDirective);
